import { GlobalWorkerOptions, version } from 'pdfjs-dist';

let configured = false;

/** Ensure pdf.js uses a worker that matches the installed pdfjs-dist version. */
export function configurePdfjsWorker(): void {
    if (configured) return;
    configured = true;
    GlobalWorkerOptions.workerSrc =
        `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/build/pdf.worker.min.mjs`;
}

configurePdfjsWorker();
